export default function PreviewEnded() {
  return (
    <div className="fixed inset-0 bg-[#05050F] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <img
          src="https://cdn.prod.website-files.com/6656cc98d077ac69272f468d/666c3d6f5a0ea57d121a1846_Logo.webp"
          alt="FixFinder"
          className="h-9 mx-auto mb-6"
        />
        <h1 className="text-white text-xl font-semibold mb-3">Thanks for visiting</h1>
        <p className="text-[#6B96D6] text-sm">
          Your preview session has ended. If you need another look, please reach out
          to your FixFinder contact for a fresh link.
        </p>
      </div>
    </div>
  );
}
